import { render, staticRenderFns } from "./base-password-box.vue?vue&type=template&id=046a781b&scoped=true&"
import script from "./base-password-box.vue?vue&type=script&lang=js&"
export * from "./base-password-box.vue?vue&type=script&lang=js&"
import style0 from "./base-password-box.vue?vue&type=style&index=0&id=046a781b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a781b",
  null
  
)

export default component.exports